import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Menu } from '@fiverr-private/orca';
import If from '../../../../lib/If';
import { useHeaderContext } from '../../../../modern/context/HeaderContext';
import { SellerLogoDashboardLink } from '../../../LogoMakerLinks';
import {
    SellerOrdersLink,
    SellerGigsLink,
    SellerEarningsLink,
    SellerProfileLink,
    SellerManageCatalogLink,
    SellerBriefsLink,
} from '../../../SellerLinks';
import SellerDropdown from '../../SellerDropdown';

const MyBusiness = () => {
    const { user } = useHeaderContext();

    return (
        <SellerDropdown
            triggerLabel={<I18n k="header.submenu.my_business" />}
            menu={
                <Menu className="seller-menu">
                    <Menu.Item>
                        <SellerOrdersLink sellerId={user.id} sellerUsername={user.username} />
                    </Menu.Item>
                    <If condition={user.dynamicMatchingEligibility}>
                        <Menu.Item>
                            <SellerBriefsLink sellerId={user.id} />
                        </Menu.Item>
                    </If>
                    <Menu.Divider />
                    <Menu.Item>
                        <SellerGigsLink sellerId={user.id} sellerUsername={user.username} />
                    </Menu.Item>
                    <If condition={user.isSellerRolesVisible}>
                        <Menu.Item>
                            <SellerManageCatalogLink sellerId={user.id} />
                        </Menu.Item>
                    </If>
                    <Menu.Item>
                        <SellerProfileLink sellerId={user.id} sellerUsername={user.username} />
                    </Menu.Item>
                    <If condition={!!user.makersProjectEligible}>
                        <Menu.Item>
                            <SellerLogoDashboardLink sellerId={user.id} />
                        </Menu.Item>
                    </If>
                    <Menu.Divider />
                    <If condition={!user.isPending}>
                        <Menu.Item>
                            <SellerEarningsLink sellerId={user.id} sellerUsername={user.username} />
                        </Menu.Item>
                    </If>
                </Menu>
            }
        />
    );
};

export default MyBusiness;
